import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

//Import Custom Compoenet
import useViewport from '../useViewport';

function ProductTypeTwo ( props ) {
  const { isImageLoad = true } = props;
  const { width } = useViewport();
  const breakpoint = 992;

  let { addClass = "", product } = props;

  const htmlString = product.product_short_description ? product.product_short_description : "";
  const product_short_description = htmlString.replace(/<[^>]+>/g, '');

  return (
    <div className={ `product-default ${addClass}` } style={ props.style }>
      <figure>
        {
          isImageLoad ?
            <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category.category_slug}/${product.variants.length > 0 ? product.variants.slice(0, 1).map(variant => variant.product_variant_slug) : product.product_slug}`}>
              <div className="lazy-overlay bg-3"></div>
              {
                product.images.slice(0, 1).map(image => (
                  <LazyLoadImage
                    key={image.product_image_id}
                    alt={product.product_name}
                    src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
                    threshold={500}
                    effect="black and white"
                  />
                ))
              }
              {
                width > breakpoint ?
                  product.images.length >= 2 ?
                    product.images.slice(1, 2).map(image => (
                      <LazyLoadImage
                        key={image.product_image_id}
                        alt={product.product_name}
                        src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
                        threshold={500}
                        effect="black and white"
                        wrapperClassName="product-image-hover"
                      />
                    ))
                  : null
                : null
              }
            </Link>
          : null
          // <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category.category_slug}/${product.product_slug}`}>
          //   {
          //     product.images.slice(0, 1).map(image => (
          //       <span key={image.product_image_id}>
          //         <img
          //           src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
          //           className="first-image"
          //           alt="product"
          //         />
          //       </span>
          //     ))
          //   }
          //   {
          //     product.images.length >= 2 ?
          //       product.images.slice(1, 2).map(image => (
          //         <span key={image.product_image_id} className="product-image-hover">
          //           <img
          //             src={'https://d22u7e6casvzfe.cloudfront.net/uploads/products/320x320/' + image.product_image}
          //             className="last-image"
          //             alt="product"
          //           />
          //         </span>
          //       ))
          //     : null
          //   }
          // </Link>
        }

        {/* <div className="label-group">
          {
            product.discount && product.salePrice ?
              <span className="product-label label-sale">{ product.discount }% OFF</span>
            : ""
          }
          {
            product.salePrice ?
              <span className="product-label label-sale">PROMOCJA</span>
            : ""
          }
          {
            !product.salePrice && product.featured ?
              <span className="product-label label-hot">hot</span>
            : ""
          }
          {
            !product.salePrice && product.new ?
              <span className="product-label label-new">new</span>
            : ""
          }
        </div> */}
      </figure>

      <div className="product-details">
        <div className="category-list">
          <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category.category_slug}`} className="product-category">{product.category.category_name}</Link>
        </div>
        <h2 className="product-title">
          <Link to={`${process.env.PUBLIC_URL}/produkty/${product.category.category_slug}/${product.variants.length > 0 ? product.variants.slice(0, 1).map(variant => variant.product_variant_slug) : product.product_slug}`}>{product.product_name}</Link>
        </h2>
        {/* <div className="ratings-container">
          <div className="product-ratings">
            <span className="ratings" style={ { width: 20 * product.rating + '%' } }></span>
            <span className="tooltiptext tooltip-top">{ product.rating.toFixed( 2 ) }</span>
          </div>
        </div> */}
        <p className="product-description">
          { product_short_description }
        </p>
        {/* {
          product.salePrice ?
            <div className="price-box">
              <span className="old-price">{ product.price.toFixed( 2 ) } zł</span>
              <span className="product-price">{ product.salePrice.toFixed( 2 ) } zł</span>
            </div>
          :
          <div className="price-box">
              <span className="product-price">{ product.price.toFixed( 2 ) } zł</span>
          </div>
        } */}
        <div className="product-action">
          {/* <button className="btn-icon btn-add-cart" onClick={ () => addToCart( product ) } title="Add To Cart"><i className="icon-bag"></i>DODAJ DO KOSZYKA</button> */}

          {/* <Link to={ `${process.env.PUBLIC_URL}/ulubione` } className={ `btn-icon-wish ${isInWishlist ? 'checked' : ''}` } onClick={ onWishlistClick } title={ `${isInWishlist === true ? 'Idź do ulubionych' : 'Dodaj do ulubionych'}` }>
            <i className="icon-heart"></i>
          </Link> */}

          {/* <Link to="#" className="btn-quickview" title="Szybki podgląd" onClick={ ( e ) => { e.preventDefault(); showQuickView( product ) } }>
            <i className="fas fa-external-link-alt"></i>
          </Link> */}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ( state ) => {
  return {
    wishlist: state.wishlist.list ? state.wishlist.list : []
  }
}

export default connect( mapStateToProps )( ProductTypeTwo );

